module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "600",
      "height": "500"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40244856!./~/vue-loader/lib/selector.js?type=template&index=0!./src/d3-components/bubbles-nested-routes/bubbles.vue
// module id = 124
// module chunks = 1